import { render, staticRenderFns } from "./SciSmart.vue?vue&type=template&id=569c5f4a&scoped=true&"
import script from "./SciSmart.vue?vue&type=script&lang=js&"
export * from "./SciSmart.vue?vue&type=script&lang=js&"
import style0 from "./SciSmart.vue?vue&type=style&index=0&id=569c5f4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569c5f4a",
  null
  
)

export default component.exports